import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import mask from 'jquery-mask-plugin'
import serializer from 'form-serializer'
import datetimepicker from 'jquery-datetimepicker'
import "jquery-datetimepicker/jquery.datetimepicker.css"

import "../../css/template/elements.css"
import "../../css/blocks/profile.css"


export default class extends Controller {



    saveForm(){
        let formData = $($("#profile")[0]).serializeObject();
        formData.clientPhone = formData.clientPhone.replace(/[^0-9]/g, ''); //убрали все кроме чисел

        //formData.clientDateBirth = formData.clientDateBirth.replace(/0?(\d+)\.0?(\d+)\.(\d+)/, '$3-$2-$1'); // ГГГГ-ММ-ДД
        let userInfoData = JSON.stringify(formData);
        $.ajax({
            method: 'post',
            url: 'https://api.actualoptic.kz:8443/patient/only/'+ usertoken,
            data: userInfoData,
            format:'json',
            dataType: 'json',
            contentType: "application/json",
            acync: false,
            success: function(result){
                $('#profileBox').prepend('' +
                    '<div class="alert alert-success" role="alert" id="message">\n' +
                    'Данные профиля изменены' +
                    '</div>');
                $("#message").delay(5000).slideUp(300);
            },
            error(error){
                console.debug('ERROR')
            }
        });
    }

    userFormCheck(){
        let checkInputName = $('#profileName');
        let checkInputSurname = $('#profileSurname');
        let checkInputBirthday = $('#profileBirthday');

        checkInputName.on('input', function() {
            if (checkInputName.val().length === 0){
                checkInputName.addClass('invalid');
            } else {
                checkInputName.removeClass('invalid');
            }

            if (checkInputName.val().length === 0 ||
                checkInputSurname.val().length === 0 ||
                checkInputBirthday.val().length === 0
            ){
                $('#profileBtn').attr('disabled', 'disabled')
            } else {
                $('#profileBtn').removeAttr('disabled');
            }
        }) ;

        checkInputSurname.on('input', function() {
            if (checkInputSurname.val().length === 0){
                checkInputSurname.addClass('invalid');
            } else {
                checkInputSurname.removeClass('invalid');
            }

            if (checkInputName.val().length === 0 ||
                checkInputSurname.val().length === 0 ||
                checkInputBirthday.val().length === 0
            ){
                $('#profileBtn').attr('disabled', 'disabled')
            } else {
                $('#profileBtn').removeAttr('disabled');
            }
        }) ;

        checkInputBirthday.on('input', function() {
            if (checkInputBirthday.val().length === 0){
                checkInputBirthday.addClass('invalid');
            } else {
                checkInputBirthday.removeClass('invalid');
            }

            if (checkInputName.val().length === 0 ||
                checkInputSurname.val().length === 0 ||
                checkInputBirthday.val().length === 0
            ){
                $('#profileBtn').attr('disabled', 'disabled')
            } else {
                $('#profileBtn').removeAttr('disabled');
            }
        }) ;

    }


    connect() {
         $.ajax({
                   type: "get",
                   url: 'https://api.actualoptic.kz:8443/cabinet/'+ usertoken,
                   contentType: "application/json",
                   acync: false,
                   success: function(data){
                       let birthday = new Date(data.patient.ClientDateBirth);
                       let birthdayDay = birthday.getDate();
                       if (birthdayDay < 10){
                           birthdayDay = '0' + birthdayDay
                       }
                       let birthdayMonth = (birthday.getMonth())+1;
                       if (birthdayMonth < 10){
                           birthdayMonth = '0' + birthdayMonth
                       }
                       let clientAge = birthdayDay + '.' + birthdayMonth + '.' + birthday.getFullYear();
                       let clientPhone = (data.patient.Phone);
                       $('#profileId').val(data.patient.ID);
                       $('#profileName').val(data.patient.ClientName);
                       $('#profileSurname').val(data.patient.ClientSurname);
                       $('#profileBirthday').val(clientAge);
                       $('#profilePhone').val(clientPhone).mask('+0 (000) 000-00-00');
                   },
                   error(error){
                       console.debug(error);
                       //window.location.replace("404.html");
                   }
               });

        //для поля даты
        $.datetimepicker.setLocale('ru');
        $('#profileBirthday').datetimepicker({
            timepicker:false,
            format:'d.m.Y',
            //maxDate:'0',
            maxDate:'-1970/01/02'
        });

        this.userFormCheck();

    }
}